import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import ContactForm from "../forms/contactForm";
import CtaOffer from "../common/ctaOffer";

function Offer3PraceZiemne() {
  return (
    <>
      {/* HERO */}
      <section className="relative overflow-x-hidden flex flex-col lg:flex-row items-center justify-between lg:min-h-[60vh] p-6 lg:px-12 lg:pt-48 lg:pb-36 gap-6">
        <img
          className="absolute w-full h-full object-cover z-10 top-0 left-0"
          src="https://magazyn.drzewus.pl/wp-content/uploads/2025/03/prace-ziemne-Large.jpeg"
          alt="Prace ziemne - profesjonalne roboty ziemne - Drzewus"
        />
        <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
        <div className="flex flex-col items-start justify-center gap-2 z-30">
          <h1 className="text-3xl lg:text-6xl text-white text-left">
            Prace ziemne w ogrodzie minikoparką Gdańsk, Gdynia, Wejherowo
          </h1>
          <h2 className="text-xl lg:text-3xl text-white text-left">
            Korytowanie, drenaże i przygotowanie podłoża pod nasadzenia
          </h2>
          <p className="text-white text-base lg:text-xl max-w-[850px] text-left">
            Tworzenie wymarzonego ogrodu w Gdańsku, Gdyni, Kartuzach czy na Kaszubach wymaga precyzyjnych prac ziemnych. Wykonujemy drenaże odwadniające działkę, korytowanie pod ścieżki i podjazdy, wymianę gruntu na żyzny oraz formowanie architektonicznych skarp. Nasz kompaktowy sprzęt wjedzie na każdą posesję bez uszkadzania istniejących elementów przestrzeni.
          </p>
          <a href="#wiecej">
            <button className="button-yellow">Dowiedz się więcej</button>
          </a>
        </div>
        <div className="z-30 max-w-[500px] flex flex-col items-center justify-center">
          {" "}
          <ContactForm />
        </div>
      </section>
      {/* CONTENT */}
      <section
        id="wiecej"
        className="p-6 lg:px-24 lg:py-12 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-12"
      >
        <div className="lg:col-span-1 flex flex-col gap-6">
          <div className="flex flex-col gap-2 p-6 rounded-xl bg-green w-full">
            <a
              href="#1"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Prace ziemne
            </a>
            <a
              href="#2"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Rodzaje robót ziemnych
            </a>
            <a
              href="#3"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Budowlane prace ziemne
            </a>
            <a
              href="#4"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Porządkowe roboty ziemne
            </a>
            <a
              href="#5"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Roboty ziemne wykończeniowo-porządkowe
            </a>
            <a
              href="#6"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Dlaczego warto wybrać naszą firmę
            </a>
            <a
              href="#7"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Ile kosztują roboty ziemne
            </a>
            <a
              href="#8"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Grunt to dobry wykonawca
            </a>
          </div>
          <CtaOffer />
        </div>
        <div className="lg:col-span-2 flex flex-col items-start justify-start text-left gap-2 content-offer">
          <h2 id="1">Prace ziemne</h2>
          <p>
            <strong>Prace ziemne w ogrodzie</strong> to kluczowy krok przy kreowaniu wymarzonej przestrzeni wokół domu. Odpowiednie przygotowanie gruntu pod trawnik, rabaty roślinne czy drenaż chroni ogród przed zalewaniem i zapewnia zdrowy wzrost roślinności.
          </p>
          <p>
            Zlecając ukształtowanie terenu i zakładanie ogrodu jednej doświadczonej firmie, unikasz chaosu organizacyjnego oraz oszczędzasz na kosztach transportu maszyn i robocizny.
          </p>

          <h2 id="2">Rodzaje robót ziemnych</h2>
          <p>Ogrodowe roboty ziemne, które wykonujemy, obejmują m.in.:</p>
          <ul>
            <li>
              <strong>roboty ziemne podstawowe</strong>
            </li>
            <li>
              <strong>roboty ziemne porządkowe</strong>
            </li>
            <li>
              <strong>roboty ziemne wykończeniowo-porządkowe</strong>
            </li>
          </ul>
          <p>
            Powyższe zadania realizujemy z użyciem nowoczesnego sprzętu ogrodniczego, co pozwala zminimalizować ryzyko naruszenia istniejącej infrastruktury ogrodowej. Nasi operatorzy dbają o to, by każda praca była wykonana precyzyjnie.
          </p>

          <h2 id="3">Budowlane prace ziemne</h2>
          <p>
            Nasz park maszynowy jest przystosowany do pracy na zagospodarowanych posesjach. W ramach podstawowych prac ziemnych pod ogrody oferujemy:
          </p>
          <ul>
            <li>wykopy rowów</li>
            <li>wykop pod skarpę</li>
            <li>wykop pod szambo</li>
            <li>kształtowanie terenu</li>
            <li>wykop pod piwniczkę</li>
            <li>wykop pod ziemiankę</li>
            <li>wykopy pod rury kanalizacyjne</li>
            <li>wykopy pod przyłącza gazowe</li>
            <li>wykopy pod fundamenty domu</li>
            <li>wykopy pod kable energetyczne i światłowody</li>
            <li>wykop i utwardzenie drogi dojazdowej do posesji</li>
          </ul>

          <h2 id="4">Porządkowe roboty ziemne</h2>
          <p>
            Zapewniamy również pełne uporządkowanie terenu przed rozpoczęciem nasadzeń. Usługa ta obejmuje:
          </p>
          <ul>
            <li>wycinka drzew</li>
            <li>frezowanie pni</li>
            <li>niwelacja terenu</li>
            <li>mulczowanie terenu</li>
            <li>karczowanie pniaków</li>
            <li>usuwanie pniaków z korzeniami pozostałych po wycince drzew</li>
          </ul>

          <h2 id="5">Roboty ziemne wykończeniowo-porządkowe</h2>
          <p>Dodatkowo na życzenie klienta realizujemy specjalistyczne wykopy pod infrastrukturę ogrodową:</p>
          <ul>
            <li>mikroniwelacje</li>
            <li>wyrównywanie skarp</li>
            <li>profilowanie nasypów</li>
            <li>zagęszczanie podłoży i skarp</li>
            <li>zbieranie żyznej warstwy ziemi</li>
            <li>wykopy pod stopy i ławy fundamentowe</li>
            <li>układanie darni oraz ziemi roślinnej w terenie</li>
            <li>wyrównywanie dna szerokoprzestrzennych wykopów</li>
          </ul>
          <p>
            Ręczne przekopywanie i korytowanie posesji pod ścieżki ogrodowe zajmuje mnóstwo czasu. Użycie minikoparek wyposażonych w gumowe gąsienice pozwala wykonać te prace precyzyjnie i bez niszczenia nawierzchni.
          </p>

          <h2 id="6">Dlaczego warto wybrać naszą firmę</h2>
          <p>
            Nasi operatorzy maszyn to doświadczeni specjaliści, którzy doskonale radzą sobie z pracą w ciasnych przestrzeniach ogrodowych, omijając instalacje podziemne i korzenie cennych drzew.
          </p>
          <p>
            Dzięki naszej wiedzy z zakresu ogrodnictwa i architektury krajobrazu, łączymy precyzję robót ziemnych z dbałością o optymalne warunki glebowe dla roślin.
          </p>
          <p>
            Z zaangażowaniem podchodzimy do każdego wyzwania terenowego – niezależnie od stopnia skomplikowania ukształtujemy teren tak, aby spełniał wszystkie Twoje wymagania estetyczne i użytkowe.
          </p>

          <h2 id="7">Ile kosztują roboty ziemne</h2>
          <p>
            Każdy ogród wymaga indywidualnego podejścia, dlatego przed rozpoczęciem prac bezpłatnie przyjeżdżamy na wizję lokalną, podczas której pomagamy dobrać optymalne rozwiązania drenażowe i niwelacyjne.
          </p>
          <p>
            Koszt ogrodowych prac ziemnych zależy od ukształtowania terenu, rodzaju gleby oraz wielkości wykopów. Prześlij nam krótki opis za pomocą formularza, a przygotujemy dla Ciebie jasną i przejrzystą ofertę cenową.
          </p>
          <p>
            Wybierając pakiety usług (np. drenaż + wyrównanie terenu + trawnik), zyskujesz lepsze warunki cenowe oraz minimalizujesz koszty logistyczne związane ze sprowadzeniem maszyn.
          </p>

          <h2 id="8">Grunt to dobry wykonawca</h2>
          <p>
            Zastąpienie ciężkiej pracy fizycznej precyzyjnym sprzętem to podstawa nowoczesnego wykonawstwa. Zapewniamy szybkie tempo prac i gwarantujemy rzetelność, opierając się na latach doświadczenia w branży ogrodniczo-ziemnej.
          </p>
          <p>
            Nasza oferta łączy w sobie usługi ziemne z pełną gamą prac ogrodniczych. Poczynając od melioracji i drenaży, przez niwelację terenu pod trawniki, aż po budowę małej architektury ogrodowej oraz kompletne nasadzenia roślinne według dowolnego projektu.
          </p>
          <p>
            Chętnie doradzimy i pomożemy zaplanować optymalny układ funkcjonalny Twojej działki. Nasze doświadczenie pozwala unikać częstych błędów przy kształtowaniu spadków terenu.
          </p>
          <p>Opowiedz nam o swojej wizji ogrodu, a my zajmiemy się profesjonalną stroną techniczną robót ziemnych.</p>
        </div>
      </section>
      {/* PORTFOLIO */}
      <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="flex flex-col items-center justify-center mb-6">
          <h2 className="uppercase color-yellow text-xl text-center">
            Nasze realizacje
          </h2>
          <h3 className="text-3xl lg:text-5xl color-green text-center">
            Spójrz jak pomogliśmy<br></br>
            <span className="color-yellow">naszym Klientom</span>
          </h3>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/new-praceziemne-0.jpeg"
              alt="Roboty ziemne - realizacja Drzewus nr 1"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/new-praceziemne-1.jpeg"
              alt="Roboty ziemne - realizacja Drzewus nr 2"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/new-praceziemne-2.jpeg"
              alt="Roboty ziemne - realizacja Drzewus nr 3"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/new-praceziemne-3.jpeg"
              alt="Roboty ziemne - realizacja Drzewus nr 4"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/new-praceziemne-4.jpeg"
              alt="Roboty ziemne - realizacja Drzewus nr 5"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/new-praceziemne-5.jpeg"
              alt="Roboty ziemne - realizacja Drzewus nr 6"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/04/prace-ziemne.jpeg"
              alt="Roboty ziemne - realizacja Drzewus nr 7"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/new-praceziemne-7.jpeg"
              alt="Roboty ziemne - realizacja Drzewus nr 8"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/new-praceziemne-8.jpeg"
              alt="Roboty ziemne - realizacja Drzewus nr 9"
              className="h-full object-cover w-full"
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Offer3PraceZiemne;
